import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SavedJobsResult from './SavedJobsResult'

class SavedJobsWrapper extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    savedJobs: PropTypes.array.isRequired,
  }

  render() {
    const { onDelete, savedJobs } = this.props

    return (
      <div>
        <div
          className="my-3 mx-2 p-2 shadow rounded"
          style={{ backgroundColor: '#EFF5FC', fontSize: 14 }}
        >
          <i className="fal fa-info-circle mr-2" />
          <span style={{ display: 'inline' }}>
            We made a few updates to our job board! Jobs saved before 7/25/24 will open an apply
            link. Jobs saved after 7/25/24 will open more details.
          </span>
        </div>
        {savedJobs.map(savedJob => (
          <SavedJobsResult job={savedJob} onDelete={onDelete} key={savedJob._id} />
        ))}
      </div>
    )
  }
}

export default SavedJobsWrapper



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/SavedJobs/SavedJobsWrapper.js